import React, { useState } from "react";
import NiaContainer from "./NiaContainer/NiaContianer";
import HeaderSimple from "./HeaderSimple/HeaderSimple";
import IAHeader from "./IAHeader";
import { useHeaderInfoContext } from "../context/HeaderInfoContext";

export default function Header({
  cachedAemMenuItems,
  cachedFilteredItemMap,
  headerInfo: initialHeaderInfo,
  contract,
  isCES,
  customCatalogData,
  featureFlags
}) {
  const [isOpen, setIsOpen] = useState(false)
  const { headerInfo: contextHeaderInfo } = useHeaderInfoContext()
  
  // Use headerInfo from context if available, otherwise fall back to props
  const currentHeaderInfo = contextHeaderInfo || initialHeaderInfo
  
  return (
    <>
      {isCES ? (
        <HeaderSimple
          cachedAemMenuItems={cachedAemMenuItems}
          cachedFilteredItemMap={cachedFilteredItemMap}
          headerInfo={currentHeaderInfo}
          setIsOpen={setIsOpen}
          featureFlags={featureFlags}
        />
      ) : (
        <IAHeader
          cachedAemMenuItems={cachedAemMenuItems}
          cachedFilteredItemMap={cachedFilteredItemMap}
          headerInfo={currentHeaderInfo}
          contract={contract}
          setIsOpen={setIsOpen}
          featureFlags={featureFlags}
        />
      )}
      <NiaContainer
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        headerInfo={currentHeaderInfo}
        customCatalogData={customCatalogData}
        featureFlags={featureFlags}
      />
    </>
  )
}